import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { RegistrationModal } from "@/components/RegistrationModal";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Disciplines } from "@/components/sections/Disciplines";
import { Teachers } from "@/components/sections/Teachers";
import { Schedule } from "@/components/sections/Schedule";
import { Workshops } from "@/components/sections/Workshops";
import { Company } from "@/components/sections/Company";
import { Projects } from "@/components/sections/Projects";
import { Events } from "@/components/sections/Events";
import { Gallery } from "@/components/sections/Gallery";
import { News } from "@/components/sections/News";
import { Newsletter } from "@/components/sections/Newsletter";

export default function Home() {
  const [regOpen, setRegOpen] = useState(false);
  const openReg = () => setRegOpen(true);

  return (
    <div className="grain relative">
      <Navbar onRegister={openReg} />
      <main>
        <Hero onRegister={openReg} />
        <About />
        <Disciplines />
        <Teachers />
        <Schedule onRegister={openReg} />
        <Workshops />
        <Company />
        <Projects />
        <Events />
        <Gallery />
        <News />
        <Newsletter />
      </main>
      <Footer onRegister={openReg} />
      <RegistrationModal open={regOpen} onOpenChange={setRegOpen} />
    </div>
  );
}
